import React, { useState } from 'react';
import { Table, Tooltip, Button, Checkbox } from 'antd';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import './MapaCauca.css';
import { FileExcelOutlined } from '@ant-design/icons';

const TablaProyectos = ({ data }) => {
    const [mostrarEnEjecucion, setMostrarEnEjecucion] = useState(false);
    const [mostrarConApropiacion, setMostrarConApropiacion] = useState(false);

    // Datos filtrados según los checks seleccionados
    const datosFiltrados = data.filter((record) => {
        if (mostrarEnEjecucion && !(record.apropiacionVigente > 0 && record.comprometidoVigente > 0)) {
            return false;
        }
        if (mostrarConApropiacion && !(record.apropiacionVigente > 0 && record.comprometidoVigente === 0)) {
            return false;
        }
        return true;
    });

    // Configuración de columnas para la tabla
    const columns = [
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Radicado</span>,
            dataIndex: 'radicado',
            key: 'radicado',
            width: 100,
            align: 'center',
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>BPIN</span>,
            dataIndex: 'bpin',
            key: 'bpin',
            width: 100,
            align: 'center',
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Vigencia Inicial</span>,
            dataIndex: 'vigenciaInicial',
            key: 'vigenciaInicial',
            width: 110,
            align: 'center',
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Vigencia Final</span>,
            dataIndex: 'vigenciaFinal',
            key: 'vigenciaFinal',
            width: 120,
            align: 'center',
        },

        {
            title: <span style={{ whiteSpace: 'nowrap' }}>apropiacionVigente</span>,
            dataIndex: 'apropiacionVigente',
            key: 'apropiacionVigente',
            width: 120,
            align: 'center',
        },

        {
            title: <span style={{ whiteSpace: 'nowrap' }}>comprometidoVigente</span>,
            dataIndex: 'comprometidoVigente',
            key: 'comprometidoVigente',
            width: 120,
            align: 'center',
        },

        {
            title: <span style={{ whiteSpace: 'nowrap' }}>certificadoVigente</span>,
            dataIndex: 'certificadoVigente',
            key: 'certificadoVigente',
            width: 120,
            align: 'center',
        },

        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Fecha Radicado</span>,
            dataIndex: 'fechaRadicado',
            key: 'fechaRadicado',
            width: 120,
            align: 'center',
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>En ejecución</span>,
            dataIndex: 'comprometidoVigente',
            key: 'comprometidoVigente',
            width: 150,
            align: 'center',
            render: (text, record) =>
                record.apropiacionVigente > 0 && record.comprometidoVigente > 0 ? 'Sí' : 'No',
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Con apropiación</span>,
            dataIndex: 'certificadoVigente',
            key: 'certificadoVigente',
            width: 150,
            align: 'center',
            render: (text, record) =>
                record.apropiacionVigente > 0 && record.certificadoVigente === 0 ? 'Sí' : '-',
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Sin apropiación</span>,
            dataIndex: 'apropiacionVigente',
            key: 'apropiacionVigente',
            width: 150,
            align: 'center',
            render: (text, record) => (record.apropiacionVigente === 0 ? 'Sí' : '-'),
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Nombre del Proyecto</span>,
            dataIndex: 'nombre',
            key: 'nombre',
            fixed: 'left',
            render: (text) => (
                <Tooltip title={text} overlayStyle={{ cursor: 'pointer' }}>
                    <span
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'block',
                        }}
                    >
                        {text.length > 50 ? `${text.slice(0, 50)}...` : text}
                    </span>
                </Tooltip>
            ),
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Total Inversión</span>,
            dataIndex: 'total',
            key: 'total',
            render: (value) => (
                <span style={{ whiteSpace: 'nowrap' }}>$ {value.toLocaleString('es-CO')}</span>
            ),
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Dependencia</span>,
            dataIndex: 'dependencia',
            key: 'dependencia',
            render: (text) => (
                <Tooltip title={text} overlayStyle={{ cursor: 'pointer' }}>
                    <span
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'block',
                        }}
                    >
                        {text.length > 50 ? `${text.slice(0, 50)}...` : text}
                    </span>
                </Tooltip>
            ),
        },
        {
            title: <span style={{ whiteSpace: 'nowrap' }}>Localización</span>,
            dataIndex: 'municipios',
            key: 'municipios',
            render: (municipios) => {
                const text = municipios.map((mun) => mun.nomMunicipio).join(', ');
                return (
                    <Tooltip title={text} overlayStyle={{ cursor: 'pointer' }}>
                        <span
                            style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'block',
                            }}
                        >
                            {text.length > 50 ? `${text.slice(0, 50)}...` : text}
                        </span>
                    </Tooltip>
                );
            },
        },
    ];

    // Función para exportar los datos a Excel
    const exportToExcel = () => {
        const exportData = datosFiltrados.map((item) => ({
            Radicado: item.radicado,
            BPIN: `${item.bpin}`,
            "Vigencia Inicial": item.vigenciaInicial,
            "Vigencia Final": item.vigenciaFinal,
            "Fecha Radicado": item.fechaRadicado,
            "En ejecución":
                item.apropiacionVigente > 0 && item.comprometidoVigente > 0 ? 'Sí' : 'No',
            "Con apropiación":
                item.apropiacionVigente > 0 && item.comprometidoVigente === 0 ? 'Sí' : '-',
            "Nombre del Proyecto": item.nombre,
            "Total Inversión": item.total.toString(),
            "comprometidoVigente": item.comprometidoVigente.toString(),
            "apropiacionVigente": item.apropiacionVigente.toString(),
            "certificadoVigente": item.certificadoVigente.toString(),
            Dependencia: item.dependencia,
            Localización: item.municipios.map((mun) => mun.nomMunicipio).join(', '),
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Proyectos');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(dataBlob, 'Tángara - Proyectos de Inversión.xlsx');
    };

    return (
        <div style={{ padding: '5px' }}>
            {/* Filtros y Botón */}
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '16px',
                    marginBottom: '8px', // Reducido para móviles
                }}
            >
                <div style={{ flex: '1 1 auto', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    <Checkbox
                        checked={mostrarEnEjecucion}
                        onChange={(e) => setMostrarEnEjecucion(e.target.checked)}
                    >
                        Mostrar solo "En ejecución"
                    </Checkbox>
                    <Checkbox
                        checked={mostrarConApropiacion}
                        onChange={(e) => setMostrarConApropiacion(e.target.checked)}
                    >
                        Mostrar solo "Con apropiación"
                    </Checkbox>
                </div>
                <Button
                    type="primary"
                    onClick={exportToExcel}
                    icon={<FileExcelOutlined />}
                    style={{
                        backgroundColor: '#52c41a',
                        borderColor: '#52c41a',
                        color: '#fff',
                        flex: '0 0 auto',
                    }}
                >
                    Exportar a Excel
                </Button>
            </div>

            {/* Tabla */}
            <div
                style={{
                    overflowX: 'auto', // Desplazamiento horizontal en móviles
                }}
            >
                <Table
                    dataSource={datosFiltrados}
                    columns={columns}
                    scroll={{ x: 'max-content' }} // Permite que se adapte al contenido
                    rowKey="radicado"
                    pagination={{
                        pageSizeOptions: ['20', '30', '50', '100'],
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        showTotal: (total, range) =>
                            `${range[0]}-${range[1]} de ${total} registros`,
                    }}
                    size="small" // Reduce el tamaño de la tabla
                    style={{
                        whiteSpace: 'nowrap', // Evita que el texto se divida en columnas
                    }}
                />
            </div>
        </div>

    );
};

export default TablaProyectos;
